import React, { useEffect } from "react";
import ModalStore from "core/stores/modal.store";
import { ModalAlert, ModalIcon } from "components/common-ui";
import ModalDialog from "components/ui/modal-dialog";
import ClearErrorModal from "self-service/dashboard/clear-error/clear-error-modal";
import ClearErrorStore from "self-service/dashboard/clear-error/clear-error.store";

type FixErrorProps = {
    openModal: boolean;
    store: ClearErrorStore;
    onClose?: any;
    contactDetailsHtml: string;
}

const fixErrorModalStore = new ModalStore({
    cssClassName: "custom-modal clear-error-modal",
    showClose: false
});

const defaultClearErrorMessage = "Your request has been completed successfully, if you don't see your change immediately, please wait a few minutes to refresh.";

const FixError = (props: FixErrorProps) => {
    const { openModal, store, onClose } = props;

    let pendingModal: any = null;

    useEffect(() => {
        if (openModal) {
            store.updateSmartCardNumber(undefined);
        }

        fixErrorModalStore.updateDisplay(openModal);
    }, [openModal]);

    const closePendingModal = () => {
        if (pendingModal === null) {
            return;
        }

        ModalAlert.close(pendingModal);
        pendingModal = null;
    }

    const showClearErrorErrorModal = (message = "") => {
        closePendingModal();

        return ModalAlert.error(message, "An error occured!", {
            showButton: true,
            showClose: false,
            buttonText: "Close"
        });
    }

    const clearErrorSubmittedTitle = "Clear error request submitted";

    const showClearErrorModal = (message: string | string[] = defaultClearErrorMessage, icon = "tick") => {
        closePendingModal();

        return ModalAlert.alert(clearErrorSubmittedTitle, message, {
            icon: icon,
            buttonText: "Close",
            showClose: false,
        });
    }

    const showClearErrorPendingModal = () => {
        closePendingModal();

        pendingModal = ModalAlert.loading("Submitting your request to fix this error");
    }

    const onSubmitSuccessHandler = (success: boolean) => {
        closePendingModal();

        if (!success) {
            return;
        }

        showClearErrorModal();
    };

    const onSubmitErrorHandler = (message: string) => {
        showClearErrorErrorModal(message);
    };

    const onSubmitFailedHandler = (message: string) => {
        showClearErrorModal(message, ModalIcon.error);
    };

    //Used to show clear error pending modal
    const onCloseHandler = (pendingRequest = true) => {
        onClose();

        if (pendingRequest) {
            showClearErrorPendingModal();
            return;
        }

        closePendingModal();
    };

    if (!openModal) {
        return null;
    }

    return (
        <ModalDialog store={fixErrorModalStore}>
            <ClearErrorModal
                openModal={openModal}
                onSubmitSuccessHandler={onSubmitSuccessHandler}
                onSubmitFailedHandler={onSubmitFailedHandler}
                onSubmitErrorHandler={onSubmitErrorHandler}
                store={store}
                modalClosedHandler={onCloseHandler} />
        </ModalDialog>
    );
};

export default FixError;
